import { render, staticRenderFns } from "./PagePlanAndConsumption.vue?vue&type=template&id=fa368e52&"
import script from "./PagePlanAndConsumption.vue?vue&type=script&lang=js&"
export * from "./PagePlanAndConsumption.vue?vue&type=script&lang=js&"
import style0 from "./PagePlanAndConsumption.vue?vue&type=style&index=0&id=fa368e52&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports